export default __webpack_public_path__ + "static/media/tag.7257966d.svg";